import account from './account';
import detail from './detail';
import global from './global';
import order from './order';

const stockService = {
  account,
  detail,
  global,
  order,
};

export default stockService;
